import { module } from 'modujs'
import { getData } from '../utils/html'

const EVENT = {
    RESIZE: 'resize'
}

export default class extends module {
    constructor(m) {
        super(m)

        this.delay = (window.firstHit && this.getData('delay-first-hit')) ? 2 : (this.getData('delay') || 0)

        this.hasLaunch = false
    }

    init() {
        // Create split
        setTimeout(() => {
            this.initSplit()

            // Event
            this.resizeBind = this.handleResize.bind(this)
            window.addEventListener(EVENT.RESIZE, this.resizeBind)
        }, 250)
    }

    /**
     * Create the split object with predefined parameters
     *
     */
    initSplit() {
        this.splitLines = new SplitText(this.el, { type: 'lines, words' })
        if (!this.hasLaunch) {
            TweenMax.set(this.el, { opacity: 0 })
        }
    }

    /**
     * Revert splittext
     *
     */
    revertSplit() {
        if (this.splitLines && this.splitLines.revert) {
            this.splitLines.revert()
        }
    }

    /**
     * Manage the resize
     * Revert the instance then re-create it
     *
     */
    handleResize() {
        if (this.splitLines) {
            this.revertSplit()
            this.initSplit()
        }
    }

    /**
     * Launch the animation
     *
     */
    launch() {
        if (!this.hasLaunch) {
            this.hasLaunch = true

            this.master = new TimelineMax({ delay: this.delay })
            this.master.set(this.el, { opacity: 1 })
            this.master.set(this.splitLines.lines, { overflow: 'hidden' })

            this.splitLines.lines.forEach((line, index) => {
                this.master.fromTo(line.children, 0.5, { opacity: 0, y:100 }, { opacity: 1, y: 0, ease: Power2.easeOut }, index * 0.1)
            })
        }
    }

    destroy() {
        window.removeEventListener(EVENT.RESIZE, this.resizeBind)
        if (this.master && this.master.kill) {
            this.master.kill()
        }
    }
}
